import { Container, Grid } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import { logout } from '../helpers/actions';
import { XsButton } from './XsButton';

function XsHeader() {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className='main_header'>
      <Container maxWidth='lg'>
        <Grid container alignItems='center' className='pt-2 pb-2'>
          <Grid item container xs justifyContent='space-between' alignItems='center'>
            <Grid item container xs>
              <Grid item style={location.pathname === '/requests' ? { textDecoration: 'underline' } : {}}>
                <XsButton
                  fullWidth={false}
                  icon={<i className='fas fa-file-signature fa-2x' />}
                  variant='text'
                  label='header.requests'
                  onClick={() => history.push('/requests')}
                />
              </Grid>
            </Grid>
            <Grid item>
              <XsButton
                fullWidth={false}
                icon={<i className='fas fa-sign-out-alt fa-2x' />}
                label='header.logout'
                onClick={() => logout()}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default XsHeader;
